import styled from '@emotion/styled';

export const SadaCase = styled.div`
  .ant-space-item {
    width: 100%;
  }
`;
